var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8415FF",
    d: "M41.9,-50.5C56,-38.1,70.4,-26.5,77.4,-10.2C84.4,6.2,84.1,27.3,75.2,44.1C66.3,60.9,48.8,73.5,29.4,80.3C10,87.2,-11.2,88.3,-28.4,80.8C-45.5,73.3,-58.4,57.2,-68.5,39.6C-78.7,22,-86.1,2.7,-83.9,-15.7C-81.7,-34.1,-69.9,-51.6,-54.3,-63.8C-38.7,-75.9,-19.4,-82.7,-2.7,-79.5C13.9,-76.2,27.8,-63,41.9,-50.5Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.b6a3745188542ec381eaa3458b618d97.svg";
export { ForwardRef as ReactComponent };